import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useField } from 'formik';
import isEmpty from 'lodash/isEmpty';
import { Toggle } from '@storable/canaveral-components';
import FormFieldLabel from '../FormFieldLabel';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
  }).isRequired,
  inline: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

const defaultProps = {
  className: undefined,
  description: undefined,
  inline: undefined,
  required: undefined,
};

const FormFieldToggle = ({
  className,
  description,
  inline,
  label,
  required,
  name,
  ...rest
}) => {
  const [field, meta] = useField(name);
  const error = meta.touched && !isEmpty(meta.error);
  const checked = meta.value;

  const fieldClasses = cx(
    styles.field,
    inline && styles.inline,
    className,
  );

  const labelComponent = (
    <FormFieldLabel
      description={description}
      htmlFor={field.name}
      inline={inline}
      required={required}
      title={label}
    />
  );

  return (
    <div className={fieldClasses}>
      {!inline && labelComponent}
      <div className={styles.toggle}>
        <Toggle
          data-testid="form-field-toggle"
          {...field}
          {...rest}
          checked={checked}
          id={field.name}
        />
      </div>
      {inline && labelComponent}
      {error && (
        <div className={styles.message}>
          {meta.error}
        </div>
      )}
    </div>
  );
};

FormFieldToggle.propTypes = propTypes;
FormFieldToggle.defaultProps = defaultProps;

export default FormFieldToggle;
